module.exports = __webpack_public_path__ + "img/login_logo.fcf9bb83.png";